export default {
    previewHelp: 'Staff preview · Explore the introduction your teammates receive. Choices here do not change membership, send messages or record anyone’s progress.',
    closePreview: 'Back to activation',
    back: 'Back',
    eyebrow: 'Welcome to MarketScale',
    title: 'Welcome to {company}.',
    description: 'Your team has a place to turn its knowledge into useful content. Here is a simple way to get started.',
    firstProject: 'Your team’s first content brief',
    teamGoal: 'What your team is working toward',
    noBrief: 'Start with one question you know how to answer. A short, useful recording is enough to get moving.',
    noRepeat: 'Use your company’s shared information in Studio. There is no company questionnaire to repeat.',
    continue: 'See how I can contribute',
    contributeTitle: 'Your knowledge is the starting point.',
    contributeDescription: 'You do not need to be a presenter. Share something useful from the work you already do.',
    tips: {
        question: { title: 'Start with a real question', body: 'Think of a question customers, partners or colleagues ask you often. Explain one useful answer in your own words.' },
        recording: { title: 'Keep the recording simple', body: 'Find a quiet spot, face a light source and use your phone or laptop. Aim for a short, clear answer; you can record again if you want to.' },
        review: { title: 'Work with your team', body: 'Follow your company’s review process. Keep customer details, confidential information and unapproved claims out of your recording.' },
    },
    chooseTitle: 'What would you like to do first?',
    chooseDescription: 'Pick what is useful to you today. You can explore the rest any time.',
    recordTitle: 'Make a first recording',
    recordDescription: 'Open Recording and choose a solo or team recording.',
    profileTitle: 'Make my profile useful',
    profileDescription: 'Add your expertise and a photo so teammates know who you are.',
    exploreTitle: 'Explore my channel',
    exploreDescription: 'See what your team is sharing and where you can contribute.',
    start: 'Let’s get started', saving: 'Saving…', later: 'Remind me tomorrow', skip: 'I’ll find my own way',
    error: 'We could not save your choice. Please try again.',
}
